import React from 'react';
import { Button } from "@mui/material";
import { useLanguage, useLanguageDispatch, EN, FR } from "../context/LanguageContext";

export default function LanguageToggle() {

    const lang = useLanguage();
    const toggleLanguage = useLanguageDispatch();

    return (
        <Button variant="text" id="language-button" onClick={toggleLanguage}>{lang?.startsWith(FR) ? "English" : "Français"}</Button>
    )

}